
import AbstractAsset from '@structure/Resources/AbstractAsset';
import AssetMeta from '@components/AssetMeta.vue';
import { stateAwarePath } from '@/support';

export default {
  props: {
    resource: {
      required: true,
      type: AbstractAsset,
    },
  },

  computed: {
    url() {
      return stateAwarePath(this.resource);
    },
  },

  components: {
    AssetMeta,
  },
};
